import { render, staticRenderFns } from "./BatteryChart.vue?vue&type=template&id=57d2bc58&scoped=true&"
import script from "./BatteryChart.vue?vue&type=script&lang=js&"
export * from "./BatteryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2bc58",
  null
  
)

export default component.exports